import { Box, Flex, OldText, Spinner, breakpoints } from '@gassan-ui'
import { formatPrice } from '@lib/formatPrice'
import { useBreakpoint } from '@lib/hooks/useBreakpoint'
import { rem } from 'polished'
import { FC } from 'react'

type Props = {
  price: number
  salePrice?: number
  discount: number
  status: 'idle' | 'loading'
}

const Price: FC<Props> = ({ price, salePrice, discount, status }) => {
  const isDesktop = useBreakpoint(breakpoints.large)
  return (
    <Flex
      flexDirection={['row-reverse', 'column']}
      justifyContent={['flex-end', 'flex-start']}
      alignItems={['center', 'flex-end']}
      position="relative"
      mb="1rem"
    >
      {(isDesktop || status === 'idle') && (
        <>
          <OldText
            as="span"
            mb="0.25rem"
            variant={salePrice ? 'regular' : 'regularBold'}
            style={{ textDecoration: salePrice && 'line-through' }}
          >
            {formatPrice(price, true)}
          </OldText>
          {salePrice && (
            <OldText variant="regularBold" mb={'0.25rem'} mr={['0.5rem', 'initial']} as="span">
              {formatPrice(salePrice, true)}
            </OldText>
          )}
          {discount && (
            <OldText display={['none', 'block']} mb="0.5rem" as="span">
              - {discount}%
            </OldText>
          )}
        </>
      )}
      {status === 'loading' && !isDesktop && (
        <Box color="tabaccoBrown" height={rem(26)}>
          <Spinner className="text-xs md:text-2xl" />
        </Box>
      )}
    </Flex>
  )
}

export default Price
